import React, { PropTypes, Component } from 'react';
import { Dialog, List, ListItem, Divider, FontIcon } from 'material-ui';
import SyncSectionCheckbox from '../sync-section-checkbox';
import { seasonColors } from '../../../../../utils/contracting-preset-names-codes';
import { connect } from 'react-redux';
import EditSeason from './edit-season';
import AssignDateRanges from './assign-date-ranges';
import FlatButton from '../../../../tc-ui/flat-button-with-loader';
import DateUtils from '../../../../../utils/date-utils';
import R from 'ramda';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

const propTypes = {
  onRequestClose: PropTypes.func,
  onTextFieldChange: PropTypes.func,
  contractId: PropTypes.string,
  productId: PropTypes.string,
  saveProductInfoChanges: PropTypes.func,
  data: PropTypes.object,
  takenDateRanges: PropTypes.array,
  saving: PropTypes.bool,
  onTextFieldChangeWithKeyPath: PropTypes.func,
  contractingPeriod: PropTypes.object,
  dialogOpen: PropTypes.bool,
};
class EditSeasonsDialog extends Component {
  constructor() {
    super();
    this.state = {
      showError: false,
      seasonsWithErrors: [],
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  generateSeasonErrors = (existingSeasons) => {
    const { contractingPeriod } = this.props;
    const withErrors = (existingSeasons || []).map((season, seasonIndex) => {
      const otherSeasons = R.remove(seasonIndex, 1, existingSeasons);
      const emptyRange = isNilOrEmpty(season.dateRanges);
      const inValidDates = DateUtils.notInContractingPeriod(season.dateRanges, contractingPeriod.startDate, contractingPeriod.endDate);
      const overlappingDates = season.dateRanges.some(range => DateUtils.overlapExisting({ from: range.seasonStartDate, to: range.seasonEndDate }, otherSeasons));
      return {
        ...season,
        hasError: emptyRange || inValidDates || overlappingDates,
        inValidDates,
        emptyRange,
        overlappingDates,
      };
    });
    const hasError = withErrors.some(s => s.hasError);
    this.setState({ seasonsWithErrors: withErrors, showError: hasError });
    return hasError;
  };

  saveChanges = () => {
    const {
      contractId,
      productId,
      saveProductInfoChanges,
      data,
    } = this.props;
    // filter out empty date ranges
    const processedData = {
      ...data,
      existingSeasons: data.existingSeasons.map(s => ({
        ...s,
        dateRanges: s.dateRanges.filter(dr => dr.seasonStartDate),
      })),
    };
    const hasError = this.generateSeasonErrors(processedData.existingSeasons);
    if (!hasError) {
      saveProductInfoChanges({
        contractId,
        productId,
        data: {
          ...data,
          existingSeasons: data.existingSeasons.filter(season => !DateUtils.isDateRangesWithEmptyDates(season.dateRanges)),
        },
        updateType: 'SAVE_SEASON_DATES_CHANGES',
      });
    }
  };
  
  render() {
    const {
      onRequestClose,
      onTextFieldChangeWithKeyPath,
      data,
      saving,
      contractingPeriod,
      dialogOpen,
      productName,
      ratePackageName,
    } = this.props;

    const onChange = onTextFieldChangeWithKeyPath;
    if (R.isEmpty(data) || isNaN(data.seasonIndex)) return <div />;
    const existingSeasons = this.state.showError ? this.state.seasonsWithErrors : data.existingSeasons;
    const allDateRanges = R.call(
      R.compose(R.filter(R.has('seasonStartDate')), R.chain(R.propOr([], 'dateRanges'))),
      existingSeasons,
    );
    const notAssignedRanges = DateUtils.getMissingRanges(allDateRanges, contractingPeriod);
    const someDatesNotInPeriod = DateUtils.notInContractingPeriod(
      allDateRanges,
      contractingPeriod.startDate,
      contractingPeriod.endDate,
    );
    return (
      <Dialog
        autoScrollBodyContent
        bodyStyle={{ padding: '0' }}
        contentStyle={{ maxWidth: '1200px', width: '100%' }}
        open={dialogOpen}
        actionsContainerStyle={{
          boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)',
        }}
        title={
          <div
            style={{
              backgroundColor: '#00BCD4',
              color: 'white',
              fontSize: '18px',
              padding: '12px 2%',
            }}
          >
            Edit Season  - {productName} {ratePackageName ? `(${ratePackageName})` : ''}
          </div>
        }
        actions={[
          <SyncSectionCheckbox
            sectionInEdit="seasons"
            label="Sync Updates to Other Products (If applicable)"
            labelStyle={{ marginLeft: '16px', width: '70%' }}
            style={{ float: 'left', width: '55%', top: '6px' }}
          />,
          <FlatButton
            label="Cancel"
            labelStyle={{ fontWeight: '600', marginRight: '15px' }}
            primary
            onTouchTap={onRequestClose}
          />,
          <FlatButton
            onClick={this.saveChanges}
            secondary
            loader={saving}
            label="save changes"
            labelStyle={{ fontWeight: '600' }}
          />,
        ]}
      >
        <div>
          <div style={{ display: 'flex' }}>
            <List style={{ width: '165px', marginRight: '16px', borderRight: '1px solid #e0e0e0' }}>
              {existingSeasons.map((season, seasonIndex) => (
                <ListItem
                  key={seasonIndex}
                  style={data.seasonIndex === seasonIndex ? { backgroundColor: '#e0e0e0' } : {}}
                  primaryText={
                    <div
                      style={{
                        color: seasonColors[seasonIndex] || 'rgba(0, 0, 0, 0.54)',
                        fontSize: '13px',
                      }}
                    >
                      {season.seasonName.replace('Season', '')}
                      {season.hasError ? (
                        <FontIcon
                          className="tc-icon-report"
                          style={{ color: '#f44336', marginLeft: '4px' }}
                        />
                      ) : (
                        <span />
                      )}
                    </div>
                  }
                  onTouchTap={() =>
                    onChange({ keyPath: ['data', 'seasonIndex'], value: seasonIndex })
                  }
                />
              ))}
              {!someDatesNotInPeriod && notAssignedRanges && notAssignedRanges.length ? (
                <Divider />
              ) : (
                <span />
              )}
              {!someDatesNotInPeriod && notAssignedRanges && notAssignedRanges.length ? (
                <ListItem
                  style={{ backgroundColor: data.seasonIndex === -1 ? '#e0e0e0' : '' }}
                  primaryText={<div style={{ fontSize: '13px' }}>Unassigned Dates</div>}
                  onTouchTap={() => onChange({ keyPath: ['data', 'seasonIndex'], value: -1 })}
                />
              ) : (
                <span />
              )}
            </List>
            {data.seasonIndex === -1 ? (
              <AssignDateRanges
                data={data}
                notAssignedRanges={notAssignedRanges}
                onChange={onChange}
                contractingPeriod={contractingPeriod}
              />
            ) : (
              <EditSeason
                existingSeasons={existingSeasons}
                onChange={onChange}
                contractingPeriod={contractingPeriod}
                seasonIndex={data.seasonIndex}
                selectedSeasonName={R.path([data.seasonIndex, 'seasonName'], existingSeasons)}
                selectedDateRanges={R.path([data.seasonIndex, 'dateRanges'], existingSeasons) || []}
              />
            )}
          </div>
        </div>
      </Dialog>
    );
  }
}

EditSeasonsDialog.propTypes = propTypes;
const mapStateToProps = ({ contracting }) => ({
  dialogOpen: contracting.addEditContractDialog.get('open'),
});

export default connect(mapStateToProps)(EditSeasonsDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/edit-seasons/dialog-container.jsx